module.exports = __webpack_public_path__ + "gfx/logo_safecall_pro_login.png";